var _defs, _path, _g, _circle, _circle2, _g2, _circle3, _circle4, _circle5, _circle6, _g3, _use, _use2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 900,
    height: 600,
    viewBox: "-1440 -960 2880 1920",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-224 0h448v400h-448z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: -158,
    cy: -149,
    r: 324.5
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "g"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: -199,
    cy: -118,
    r: 324.5
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "h"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: -212,
    cy: -100,
    r: 324.5
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e"
  }, /*#__PURE__*/React.createElement("circle", {
    cy: -38,
    r: 576
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "k"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: -182,
    cy: -96,
    r: 324.5
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "j"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: -213,
    cy: -91,
    r: 324.5
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: -234,
    cy: -64,
    r: 324.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "l"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M0 0v1h.5z",
    fill: "#ffde23",
    transform: "rotate(18 3.157 -.5)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    transform: "scale(-1 1)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    transform: "rotate(72)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    transform: "rotate(216)"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    transform: "rotate(72)"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-1440-960h2880V960h-2880z",
    fill: "#0f7562"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: -209,
    cy: -7,
    r: 324.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 209,
    cy: -7,
    r: 324.5
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 224,
    cy: -39,
    r: 324.5,
    fill: "#0f7562"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: -224,
    cy: -39,
    r: 324.5,
    fill: "#0f7562"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-500 285.5h291v32h-291zm0 65H500v16H-500zm0 49H500v25H-500zm0 50H500v32H-500zm0 48H500v50H-500zm1000-212H209v32h291z"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 158,
    cy: -149,
    r: 324.5,
    clipPath: "url(#f)",
    fill: "#fff"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 199,
    cy: -118,
    r: 324.5,
    clipPath: "url(#g)",
    fill: "#0f7562"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cy: -346,
    r: 130,
    fill: "#0f7562"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 212,
    cy: -100,
    r: 324.5,
    clipPath: "url(#h)",
    fill: "#fff"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "m"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: -379,
    cy: 307,
    r: 381.5,
    clipPath: "url(#i)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -370,
    cy: 343,
    r: 381.5,
    clipPath: "url(#j)",
    fill: "#0f7562"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -485,
    cy: 21,
    r: 130,
    fill: "#0f7562"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: -339,
    cy: 372,
    r: 381.5,
    clipPath: "url(#k)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-100 50 60 50h50v100h-60z"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l",
    transform: "rotate(-35 -781.005 208.25) scale(73)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l",
    transform: "rotate(-65 -386.535 208.25) scale(73)"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#m",
    transform: "scale(-1 1)"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l",
    transform: "translate(0 -492.5) scale(105.5)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMo);
export default __webpack_public_path__ + "static/media/mo.15c75b1049785c46730392182f4f031d.svg";
export { ForwardRef as ReactComponent };